import { Component, Inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, filter, take } from 'rxjs';

import { RootState } from 'src/app/reducers';
import { getCommonIdSignedInUser } from 'src/app/selectors/common-id/common-id-auth.selectors';

import { CommonIdUser } from 'src/app/models/common-id/common-id-user';
import { CONTACT_GOOGLE_FORM_URL, REQUEST_GOOGLE_FORM_URL } from 'src/app/resources/common-id-config';
import { CommonIdContactUtil } from 'src/app/utils/common-id/common-id-contact-util';
import { WINDOW_OBJECT } from '../../../../utils/injection-tokens';

@Component({
  selector: 'app-common-id-bottom-toast-banner',
  templateUrl: './bottom-toast-banner.component.html',
  styleUrls: ['./bottom-toast-banner.component.scss']
})
export class CommonIdBottomToastBannerComponent implements OnInit {
  isBannerVisible = true;
  requestFormUrl: string;
  signedInUser$: Observable<CommonIdUser>;

  private readonly storageKeyPrefix = 'bottomToastBannerClosedAt';
  private readonly storageKey = `${this.storageKeyPrefix}-20250609`;
  private readonly hideDuration = 14 * 24 * 60 * 60 * 1000; // 2週間をミリ秒で

  constructor(private store: Store<RootState>, @Inject(WINDOW_OBJECT) private window: Window) {}

  ngOnInit() {
    this.setUpSignedInUser();
    this.setUpRequestFormUrl();
    this.checkBannerVisibility();
    this.cleanupLocalStorageKeys();
  }

  private setUpSignedInUser() {
    this.signedInUser$ = this.store.select(getCommonIdSignedInUser).pipe(
      filter<CommonIdUser>(it => it != null),
      take(1)
    );
  }

  private setUpRequestFormUrl() {
    this.signedInUser$.subscribe(user => {
      // this.requestFormUrl = CommonIdContactUtil.getRequestGoogleFormUrl(REQUEST_GOOGLE_FORM_URL, user.commonId);
      this.requestFormUrl = CommonIdContactUtil.getGoogleFormUrl(
        'https://docs.google.com/forms/d/e/1FAIpQLScJ1QFU1eky_bk_Q1YAHDLb24GQ8swFUfjUC6LPvDC2cjPu1w/viewform?usp=pp_url&entry.734219579=<user-id>&entry.272662614=<user-agent>',
        user.commonId,
        this.window.navigator.userAgent
      );
    });
  }

  private checkBannerVisibility() {
    // バナー表示を解除後２週間はバナーを表示しない
    const closedAt = localStorage.getItem(this.storageKey);
    if (closedAt) {
      const closedTime = parseInt(closedAt, 10);
      const currentTime = Date.now();
      if (currentTime - closedTime < this.hideDuration) {
        this.isBannerVisible = false;
      }
    }
  }

  private cleanupLocalStorageKeys(): void {
    // 逆順で安全に削除
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (!key) continue;

      if (key.startsWith(this.storageKeyPrefix) && key !== this.storageKey) {
        localStorage.removeItem(key);
      }
    }
  }

  closeBanner() {
    this.isBannerVisible = false;
    const currentTime = Date.now();
    localStorage.setItem(this.storageKey, currentTime.toString());
  }
}
